<div class="booking-page">

  <!-- HEADER -->
  <div class="page-header">
    <div>
      <h2>Booking Requests</h2>
      <p>Review and manage customer booking requests</p>
    </div>
    <div class="header-stats">
      <span class="stat-badge pending" *ngIf="bookings.length > 0">
        {{ bookings.length }} Total
      </span>
    </div>
  </div>

  <!-- FILTER OPTIONS -->
  <div class="filters-container" style="display: flex; gap: 10px; margin-bottom: 20px; overflow-x: auto; padding-bottom: 5px;">
    <button *ngFor="let option of filterOptions" 
            (click)="currentFilter = option"
            style="border: none; padding: 8px 16px; border-radius: 20px; font-size: 13px; font-weight: 600; cursor: pointer; white-space: nowrap; transition: all 0.2s;"
            [ngStyle]="{'background': currentFilter === option ? '#B01E3E' : '#f3f4f6', 'color': currentFilter === option ? 'white' : '#4b5563'}">
      {{ option }}
    </button>
  </div>

  <!-- EMPTY STATE -->
  <div class="empty-state" *ngIf="filteredBookings.length === 0">
    <span class="material-symbols-outlined">event_note</span>
    <h3>No Bookings Found</h3>
    <p>No bookings match the selected filter.</p>
  </div>

  <!-- BOOKING CARDS -->
  <div class="booking-card" *ngFor="let booking of filteredBookings">

    <!-- CARD TOP ROW -->
    <div class="card-top">
      <div class="service-info">

<h3>{{ booking.serviceId.service_name }}</h3>

<button
class="btn-service-details"
(click)="openServiceDetails(booking)">

<span class="material-symbols-outlined">

info

</span>

Service Details

</button>

</div>
      <div class="header-right">
        <span class="status-badge" [ngClass]="'status-' + booking.booking_status.toLowerCase()">
          <span class="material-symbols-outlined" *ngIf="booking.booking_status === 'Pending'">schedule</span>
          <span class="material-symbols-outlined" *ngIf="booking.booking_status === 'Confirmed'">check_circle</span>
          <span class="material-symbols-outlined" *ngIf="booking.booking_status === 'Rejected'">cancel</span>
          {{ booking.booking_status }}
        </span>
        
        <span class="status-badge payment-badge" *ngIf="booking.booking_status === 'Confirmed'" [ngClass]="'payment-' + (booking.payment_status || 'pending').toLowerCase().replace(' ', '-')">
          <span class="material-symbols-outlined" *ngIf="booking.payment_status === 'Paid'">task_alt</span>
          <span class="material-symbols-outlined" *ngIf="booking.payment_status === 'Advance Paid'">payments</span>
          {{ booking.payment_status || 'Payment Pending' }}
        </span>
      </div>
    </div>

    <!-- DETAILS GRID -->
<div class="details-grid">


<!-- CUSTOMER -->

<div class="detail-box">

<div class="box-label">

<span class="material-symbols-outlined">
person
</span>

Customer

</div>


<p>
<b>
{{ booking.customer_name }}
</b>
</p>


<p>

<span class="material-symbols-outlined mini">
call
</span>

{{ booking.customer_phone }}

</p>


<p>

<span class="material-symbols-outlined mini">
mail
</span>

{{ booking.customer_email }}

</p>


</div>





<!-- EVENT -->

<div class="detail-box">


<div class="box-label">

<span class="material-symbols-outlined">
celebration
</span>

Event

</div>



<p>

<b>
{{ booking.function_name }}
</b>

</p>



<p>

<span class="material-symbols-outlined mini">
calendar_month
</span>


{{ booking.selectedDate?.day }}/{{ booking.selectedDate?.month }}/{{ booking.selectedDate?.year }}


</p>



<p>

<span class="material-symbols-outlined mini">
location_on
</span>


{{ booking.location }}


</p>




<p *ngIf="booking.additional_details">


<span class="material-symbols-outlined mini">
description
</span>


{{ booking.additional_details }}


</p>



</div>






<!-- BOOKING -->

<div class="detail-box">


<div class="box-label">

<span class="material-symbols-outlined">
receipt_long
</span>

Booking

</div>



<p>

<span class="material-symbols-outlined mini">
payments
</span>


Total Amount:

<b>
₹{{ booking.total_amount | number }}
</b>


</p>





<!-- ONLY ADVANCE PAYMENT SERVICE -->

<p *ngIf="booking.payment_type === 'ADVANCE'">


<span class="material-symbols-outlined mini">
account_balance_wallet
</span>


Advance Amount:

<b>
₹{{ booking.advance_amount | number }}
</b>


</p>






<p>


<span class="material-symbols-outlined mini">
paid
</span>


Paid Amount:

<b>
₹{{ booking.paid_amount | number }}
</b>


</p>






<p>


<span class="material-symbols-outlined mini">
pending
</span>


Pending Amount:

<b>
₹{{ booking.pending_amount | number }}
</b>


</p>




</div>



</div>

    <!-- ACTIONS — only for Pending bookings -->
    <div class="action-area" *ngIf="booking.booking_status === 'Pending'">
      <button class="btn-accept" (click)="acceptBooking(booking)">
        <span class="material-symbols-outlined">check_circle</span>
        Accept Booking
      </button>
      <button class="btn-reject-toggle" (click)="booking.showReject = !booking.showReject">
        <span class="material-symbols-outlined">cancel</span>
        Decline
      </button>
    </div>

    <!-- PAYMENT ACTIONS — for Confirmed bookings -->
    <div class="action-area" *ngIf="booking.booking_status === 'Confirmed' && booking.payment_status !== 'Paid'">
      <button class="btn-accept" (click)="markAdvancePaid(booking)" *ngIf="booking.payment_type === 'ADVANCE' && booking.payment_status !== 'Advance Paid'" style="background: #3b82f6;">
        <span class="material-symbols-outlined">payments</span>
        Advance Paid
      </button>
      <button class="btn-accept" (click)="markFullyPaid(booking)">
        <span class="material-symbols-outlined">task_alt</span>
        Fully Paid
      </button>
    </div>
    <div class="booking-progress">

  <h4>Booking Progress</h4>

  <div class="progress-grid">

    <div class="progress-item">
      <span class="material-symbols-outlined success">event_available</span>
      <div>
        <strong>Requested</strong>
        <small>{{ booking.booked_on | date:'dd MMM yyyy, hh:mm a' }}</small>
      </div>
    </div>

    <div class="progress-item" *ngIf="booking.accepted_on">
      <span class="material-symbols-outlined success">check_circle</span>
      <div>
        <strong>Accepted</strong>
        <small>{{ booking.accepted_on | date:'dd MMM yyyy, hh:mm a' }}</small>
      </div>
    </div>

    <div class="progress-item" *ngIf="booking.advance_paid_on">
      <span class="material-symbols-outlined warning">payments</span>
      <div>
        <strong>Advance Paid</strong>
        <small>
          ₹{{ booking.advance_amount }} <br>
          {{ booking.advance_paid_on | date:'dd MMM yyyy, hh:mm a' }}
        </small>
      </div>
    </div>

    <div class="progress-item" *ngIf="booking.payment_completed_on">
      <span class="material-symbols-outlined success">task_alt</span>
      <div>
        <strong>Payment Completed</strong>
        <small>{{ booking.payment_completed_on | date:'dd MMM yyyy, hh:mm a' }}</small>
      </div>
    </div>

    <div class="progress-item rejected" *ngIf="booking.rejected_on">
      <span class="material-symbols-outlined danger">cancel</span>
      <div>
        <strong>Rejected</strong>
        <small>{{ booking.rejected_on | date:'dd MMM yyyy, hh:mm a' }}</small>

        <!-- <small *ngIf="booking.reject_reason">
          {{ booking.reject_reason }}
        </small> -->
      </div>
    </div>

  </div>

</div>

    <!-- REJECT AREA -->
    <div class="reject-area" *ngIf="booking.showReject">
      <textarea [(ngModel)]="booking.reject_reason" placeholder="Reason for declining (the customer will see this)..."></textarea>
      <div class="reject-actions">
        <button class="btn-confirm-reject" (click)="rejectBooking(booking)">Send Decline</button>
        <button class="btn-cancel-reject" (click)="booking.showReject = false">Cancel</button>
      </div>
    </div>

    <!-- REJECTION REASON (shown for rejected bookings) -->
    <div class="rejection-note" *ngIf="booking.booking_status === 'Rejected' && booking.reject_reason">
      <span class="material-symbols-outlined">info</span>
      <span>Reason given: {{ booking.reject_reason }}</span>
    </div>

  </div>
  <!-- SERVICE DETAILS POPUP -->

<div
class="overlay"
*ngIf="showServiceDetails">

<div class="service-modal">

<div class="modal-header">

<h2>

Service Details

</h2>

<button
(click)="closeServiceDetails()">

✕

</button>

</div>

<div
class="modal-body"
*ngIf="selectedBooking">

<h3>

{{selectedBooking.serviceId.service_name}}

</h3>

<p>

{{selectedBooking.serviceId.service_description}}

</p>

<div class="detail-row">

<strong>

Price

</strong>

<span>

₹{{selectedBooking.total_amount}}

</span>

</div>


<div class="detail-row">

<strong>

Duration

</strong>

<span>

{{selectedBooking.serviceId.duration}}

</span>

</div>


<div class="detail-row">

<strong>

Payment Type

</strong>

<span>

{{selectedBooking.serviceId.payment?.type}}

</span>

</div>

<div class="detail-row">

<strong>

Locations

</strong>

<span>

{{selectedBooking.serviceId.service_locations?.join(', ')}}

</span>

</div>

<div>

<h4>

Included

</h4>

<div
*ngFor="let item of selectedBooking.serviceId.included || []">

✓ {{item}}

</div>

</div>

</div>


</div>

</div>

</div>